export default __webpack_public_path__ + "static/video-6-93da09ebee30fc405fb52734c6a00bb4.png";